import renderComponent from './renderComponent';

const ItemContainer = (props) => {
    return renderComponent(props);
};

export default ItemContainer;
